<template>
   <div class="text-center py-4 px-3 rounded-lg" :style="{background}">
      <h3 class="text-secondary">{{title}}</h3>
      <p class="text-white">{{desc}}</p>
      <el-button
         class="font-weight-bold text-uppercase mt-2 mb-2"
         size="mini"
         type="secondary"
         :round="true"
         @click="onClick"
         plain
      >
         Clique aqui
      </el-button>
   </div>
</template>

<script>
export default {
   name: 'AdvertiseYourBike',
   props: {
      title: {
         type: String,
         default: 'Quer cadastrar sua bike?'
      },
      desc: {
         type: String,
         default: 'Se você pretende anunciar a sua bike para locação, basta completar o seu perfil. Se for o seu caso, clique no botão abaixo.'
      },
      background: {
         type: String,
         default: '#47b54c '
      },
      ready: {
         type: Boolean
      },
      onClick: {
         type: Function,
      }
   },
   mounted() {

   },
   data() {
      return {

      }
   },
   methods: {
      handleFinalizeRegister() {

         if (!this.ready) {
            this.$confirm(`${this.user.firstName}, antes de prosseguir, por favor, complete o cadastro acima com seus dados pessoais.`, 'Warning', {
               title: "Atenção: cadastre seus dados pessoais",
               confirmButtonText: 'OK',
               showCancelButton: false
            }).then(() => {
               //this.$router.push({name: 'profile'})
            }).catch(() => {

            });
            return false
         }

         this.$router.push({name: 'finalize-register'})

      },
   },
   computed: {

   }
}
</script>

<style scoped>

</style>
